import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
const UnitaryWireframeSidePanel = () => {
  const {
    isOpen,
    togglePanel
  } = useSideOverPanel();
  const {
    currentNode
  } = useForwardNode();
  return __jsx(Transition.Root, {
    show: isOpen,
    as: Fragment
  }, __jsx(Dialog, {
    as: "div",
    className: "relative z-50",
    onClose: togglePanel
  }, __jsx(Transition.Child, {
    as: Fragment,
    enter: "ease-in-out duration-500",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in-out duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, __jsx("div", {
    className: "fixed inset-0 bg-black bg-opacity-25"
  })), __jsx("div", {
    className: "fixed inset-0 overflow-hidden z-50"
  }, __jsx("div", {
    className: "absolute inset-0 overflow-hidden"
  }, __jsx("div", {
    className: "pointer-events-none fixed inset-y-0 left-0 flex max-w-full"
  }, __jsx(Transition.Child, {
    as: Fragment,
    enter: "transform transition ease-in-out duration-500 sm:duration-700",
    enterFrom: "-translate-x-full",
    enterTo: "translate-x-0",
    leave: "transform transition ease-in-out duration-500 sm:duration-700",
    leaveFrom: "translate-x-0",
    leaveTo: "-translate-x-full"
  }, __jsx(Dialog.Panel, {
    className: "pointer-events-auto w-screen"
  }, __jsx("div", {
    className: "flex h-full flex-col overflow-y-scroll mt-14 bg-white shadow-xl"
  }, __jsx("div", {
    className: "relative flex-1 px-4 sm:px-6"
  }, currentNode)))))))));
};
export default UnitaryWireframeSidePanel;